export const measurementPreferences = {
	UsStandard: 'USStandard',
	Metric: 'Metric',
	Imperial: 'Imperial'
};

export const measurementNames = {
	heightCm: 'heightCm',
	heightFt: 'heightFt',
	heightIn: 'heightIn',
	weightKg: 'weightKg',
	weightSt: 'weightSt',
	weightLb: 'weightLb',
	goalWeightKg: 'goalWeightKg',
	goalWeightSt: 'goalWeightSt',
	goalWeightLb: 'goalWeightLb',
	waistCm: 'waistCm',
	waistIn: 'waistIn',
	thighsCm: 'thighsCm',
	thighsIn: 'thighsIn',
	hipsCm: 'hipsCm',
	hipsIn: 'hipsIn',
	chestCm: 'chestCm',
	chestIn: 'chestIn',
	armsCm: 'armsCm',
	armsIn: 'armsIn'
};

export const weekdays = [    
	'Sunday',
	'Monday',
	'Tuesday',
	'Wednesday',
	'Thursday',
	'Friday',
	'Saturday'
];

export const dnaWeightProfileStatuses = {
	DnaDataRequired: 'DnaDataRequired',
	DnaDataError: 'DnaDataError',
	Pending: 'Pending',
	Processing: 'Processing',
	ProcessingError: 'ProcessingError',
	Processed: 'Processed'
}

export const dnaSources = {
    None: { name: "I don't have a DNA kit", value: 'None' },
    Ancestry: { name: 'I have an AncestryDNA kit', value: 'Ancestry File' },
    _23andMe: { name: 'I have a 23andMe kit', value: '23andMe File' }
}

export const dnaWeightProfilePolling = {
	elapsedTimeSec: 0,
	limitSec: 120,			// sec
	incrementSec: 10,
	s3UploadRetries: 0,
	s3UploadTimeout: 300000	// ms
};

export const dnaWeightProfileInsights = {
	ObesityRiskSNPsFound: 'ObesityRiskSNPsFound',
	ObesityRiskSumGeneScore: 'ObesityRiskSumGeneScore',
	ObesityRiskSumEffectMultiplier: 'ObesityRiskSumEffectMultiplier',
	ObesityRiskSNPsAtRisk: 'ObesityRiskSNPsAtRisk',
	ObesityRiskScore: 'ObesityRiskScore',
	ObesityRiskLevel: 'ObesityRiskLevel',
	FoodSensitivityLactose: 'FoodSensitivityLactose',
	FoodSensitivityGluten: 'FoodSensitivityGluten',
	FoodSensitivitySalt: 'FoodSensitivitySalt',
	FoodSensitivityCaffeine: 'FoodSensitivityCaffeine',
	FoodSensitivityAlcohol: 'FoodSensitivityAlcohol',
	HighProteinDiet: 'HighProteinDiet',
	BitterTaste: 'BitterTaste',
	PCOS: 'PCOS',
	Pork: 'Pork',
	Grapefruit: 'Grapefruit',
	Stevia: 'Stevia',
	Cilantro: 'Cilantro',
	BeverageIntake: 'BeverageIntake',
	IronMetabolism: 'IronMetabolism',
	LeftHandedness: 'LeftHandedness',
	BodyClock: 'BodyClock',
	EmotionalEating: 'EmotionalEating'
};

export const foodSensitivityOptions = [
	{ name: 'Not sensitive', value: 'NotApplicable' },
	{ name: 'Somewhat sensitive', value: 'SlightlyImportant' },
	{ name: 'Sensitive', value: 'VeryImportant' }
];

export const IanaTimeZones = [
    { name: 'Africa/Abidjan (UTC +00:00)', value: 'Africa/Abidjan' },
    { name: 'Africa/Accra (UTC +00:00)', value: 'Africa/Accra' },
    { name: 'Africa/Addis_Ababa (UTC +03:00)', value: 'Africa/Addis_Ababa' },
    { name: 'Africa/Algiers (UTC +01:00)', value: 'Africa/Algiers' },
    { name: 'Africa/Asmara (UTC +03:00)', value: 'Africa/Asmara' },
    { name: 'Africa/Asmera (UTC +03:00)', value: 'Africa/Asmera' },
    { name: 'Africa/Bamako (UTC +00:00)', value: 'Africa/Bamako' },
    { name: 'Africa/Bangui (UTC +01:00)', value: 'Africa/Bangui' },
    { name: 'Africa/Banjul (UTC +00:00)', value: 'Africa/Banjul' },
    { name: 'Africa/Bissau (UTC +00:00)', value: 'Africa/Bissau' },
    { name: 'Africa/Blantyre (UTC +02:00)', value: 'Africa/Blantyre' },
    { name: 'Africa/Brazzaville (UTC +01:00)', value: 'Africa/Brazzaville' },
    { name: 'Africa/Bujumbura (UTC +02:00)', value: 'Africa/Bujumbura' },
    { name: 'Africa/Cairo (UTC +02:00)', value: 'Africa/Cairo' },
    { name: 'Africa/Casablanca (UTC +01:00)', value: 'Africa/Casablanca' },
    { name: 'Africa/Ceuta (UTC +02:00)', value: 'Africa/Ceuta' },
    { name: 'Africa/Conakry (UTC +00:00)', value: 'Africa/Conakry' },
    { name: 'Africa/Dakar (UTC +00:00)', value: 'Africa/Dakar' },
    { name: 'Africa/Dar_es_Salaam (UTC +03:00)', value: 'Africa/Dar_es_Salaam' },
    { name: 'Africa/Djibouti (UTC +03:00)', value: 'Africa/Djibouti' },
    { name: 'Africa/Douala (UTC +01:00)', value: 'Africa/Douala' },
    { name: 'Africa/El_Aaiun (UTC +01:00)', value: 'Africa/El_Aaiun' },
    { name: 'Africa/Freetown (UTC +00:00)', value: 'Africa/Freetown' },
    { name: 'Africa/Gaborone (UTC +02:00)', value: 'Africa/Gaborone' },
    { name: 'Africa/Harare (UTC +02:00)', value: 'Africa/Harare' },
    { name: 'Africa/Johannesburg (UTC +02:00)', value: 'Africa/Johannesburg' },
    { name: 'Africa/Juba (UTC +03:00)', value: 'Africa/Juba' },
    { name: 'Africa/Kampala (UTC +03:00)', value: 'Africa/Kampala' },
    { name: 'Africa/Khartoum (UTC +03:00)', value: 'Africa/Khartoum' },
    { name: 'Africa/Kigali (UTC +02:00)', value: 'Africa/Kigali' },
    { name: 'Africa/Kinshasa (UTC +01:00)', value: 'Africa/Kinshasa' },
    { name: 'Africa/Lagos (UTC +01:00)', value: 'Africa/Lagos' },
    { name: 'Africa/Libreville (UTC +01:00)', value: 'Africa/Libreville' },
    { name: 'Africa/Lome (UTC +00:00)', value: 'Africa/Lome' },
    { name: 'Africa/Luanda (UTC +01:00)', value: 'Africa/Luanda' },
    { name: 'Africa/Lubumbashi (UTC +02:00)', value: 'Africa/Lubumbashi' },
    { name: 'Africa/Lusaka (UTC +02:00)', value: 'Africa/Lusaka' },
    { name: 'Africa/Malabo (UTC +01:00)', value: 'Africa/Malabo' },
    { name: 'Africa/Maputo (UTC +02:00)', value: 'Africa/Maputo' },
    { name: 'Africa/Maseru (UTC +02:00)', value: 'Africa/Maseru' },
    { name: 'Africa/Mbabane (UTC +02:00)', value: 'Africa/Mbabane' },
    { name: 'Africa/Mogadishu (UTC +03:00)', value: 'Africa/Mogadishu' },
    { name: 'Africa/Monrovia (UTC +00:00)', value: 'Africa/Monrovia' },
    { name: 'Africa/Nairobi (UTC +03:00)', value: 'Africa/Nairobi' },
    { name: 'Africa/Ndjamena (UTC +01:00)', value: 'Africa/Ndjamena' },
    { name: 'Africa/Niamey (UTC +01:00)', value: 'Africa/Niamey' },
    { name: 'Africa/Nouakchott (UTC +00:00)', value: 'Africa/Nouakchott' },
    { name: 'Africa/Ouagadougou (UTC +00:00)', value: 'Africa/Ouagadougou' },
    { name: 'Africa/Porto-Novo (UTC +01:00)', value: 'Africa/Porto-Novo' },
    { name: 'Africa/Sao_Tome (UTC +00:00)', value: 'Africa/Sao_Tome' },
    { name: 'Africa/Timbuktu (UTC +00:00)', value: 'Africa/Timbuktu' },
    { name: 'Africa/Tripoli (UTC +02:00)', value: 'Africa/Tripoli' },
    { name: 'Africa/Tunis (UTC +01:00)', value: 'Africa/Tunis' },
    { name: 'Africa/Windhoek (UTC +02:00)', value: 'Africa/Windhoek' },
    { name: 'America/Adak (UTC -09:00)', value: 'America/Adak' },
    { name: 'America/Anchorage (UTC -08:00)', value: 'America/Anchorage' },
    { name: 'America/Anguilla (UTC -04:00)', value: 'America/Anguilla' },
    { name: 'America/Antigua (UTC -04:00)', value: 'America/Antigua' },
    { name: 'America/Araguaina (UTC -03:00)', value: 'America/Araguaina' },
    { name: 'America/Argentina/Buenos_Aires (UTC -03:00)', value: 'America/Argentina/Buenos_Aires' },
    { name: 'America/Argentina/Catamarca (UTC -03:00)', value: 'America/Argentina/Catamarca' },
    { name: 'America/Argentina/ComodRivadavia (UTC -03:00)', value: 'America/Argentina/ComodRivadavia' },
    { name: 'America/Argentina/Cordoba (UTC -03:00)', value: 'America/Argentina/Cordoba' },
    { name: 'America/Argentina/Jujuy (UTC -03:00)', value: 'America/Argentina/Jujuy' },
    { name: 'America/Argentina/La_Rioja (UTC -03:00)', value: 'America/Argentina/La_Rioja' },
    { name: 'America/Argentina/Mendoza (UTC -03:00)', value: 'America/Argentina/Mendoza' },
    { name: 'America/Argentina/Rio_Gallegos (UTC -03:00)', value: 'America/Argentina/Rio_Gallegos' },
    { name: 'America/Argentina/Salta (UTC -03:00)', value: 'America/Argentina/Salta' },
    { name: 'America/Argentina/San_Juan (UTC -03:00)', value: 'America/Argentina/San_Juan' },
    { name: 'America/Argentina/San_Luis (UTC -03:00)', value: 'America/Argentina/San_Luis' },
    { name: 'America/Argentina/Tucuman (UTC -03:00)', value: 'America/Argentina/Tucuman' },
    { name: 'America/Argentina/Ushuaia (UTC -03:00)', value: 'America/Argentina/Ushuaia' },
    { name: 'America/Aruba (UTC -04:00)', value: 'America/Aruba' },
    { name: 'America/Asuncion (UTC -03:00)', value: 'America/Asuncion' },
    { name: 'America/Atikokan (UTC -05:00)', value: 'America/Atikokan' },
    { name: 'America/Atka (UTC -09:00)', value: 'America/Atka' },
    { name: 'America/Bahia (UTC -03:00)', value: 'America/Bahia' },
    { name: 'America/Bahia_Banderas (UTC -05:00)', value: 'America/Bahia_Banderas' },
    { name: 'America/Barbados (UTC -04:00)', value: 'America/Barbados' },
    { name: 'America/Belem (UTC -03:00)', value: 'America/Belem' },
    { name: 'America/Belize (UTC -06:00)', value: 'America/Belize' },
    { name: 'America/Blanc-Sablon (UTC -04:00)', value: 'America/Blanc-Sablon' },
    { name: 'America/Boa_Vista (UTC -04:00)', value: 'America/Boa_Vista' },
    { name: 'America/Bogota (UTC -05:00)', value: 'America/Bogota' },
    { name: 'America/Boise (UTC -06:00)', value: 'America/Boise' },
    { name: 'America/Buenos_Aires (UTC -03:00)', value: 'America/Buenos_Aires' },
    { name: 'America/Cambridge_Bay (UTC -06:00)', value: 'America/Cambridge_Bay' },
    { name: 'America/Campo_Grande (UTC -03:00)', value: 'America/Campo_Grande' },
    { name: 'America/Cancun (UTC -05:00)', value: 'America/Cancun' },
    { name: 'America/Caracas (UTC -04:00)', value: 'America/Caracas' },
    { name: 'America/Catamarca (UTC -03:00)', value: 'America/Catamarca' },
    { name: 'America/Cayenne (UTC -03:00)', value: 'America/Cayenne' },
    { name: 'America/Cayman (UTC -05:00)', value: 'America/Cayman' },
    { name: 'America/Chicago (UTC -05:00)', value: 'America/Chicago' },
    { name: 'America/Chihuahua (UTC -06:00)', value: 'America/Chihuahua' },
    { name: 'America/Coral_Harbour (UTC -05:00)', value: 'America/Coral_Harbour' },
    { name: 'America/Cordoba (UTC -03:00)', value: 'America/Cordoba' },
    { name: 'America/Costa_Rica (UTC -06:00)', value: 'America/Costa_Rica' },
    { name: 'America/Creston (UTC -07:00)', value: 'America/Creston' },
    { name: 'America/Cuiaba (UTC -03:00)', value: 'America/Cuiaba' },
    { name: 'America/Curacao (UTC -04:00)', value: 'America/Curacao' },
    { name: 'America/Danmarkshavn (UTC +00:00)', value: 'America/Danmarkshavn' },
    { name: 'America/Dawson (UTC -07:00)', value: 'America/Dawson' },
    { name: 'America/Dawson_Creek (UTC -07:00)', value: 'America/Dawson_Creek' },
    { name: 'America/Denver (UTC -06:00)', value: 'America/Denver' },
    { name: 'America/Detroit (UTC -04:00)', value: 'America/Detroit' },
    { name: 'America/Dominica (UTC -04:00)', value: 'America/Dominica' },
    { name: 'America/Edmonton (UTC -06:00)', value: 'America/Edmonton' },
    { name: 'America/Eirunepe (UTC -05:00)', value: 'America/Eirunepe' },
    { name: 'America/El_Salvador (UTC -06:00)', value: 'America/El_Salvador' },
    { name: 'America/Ensenada (UTC -07:00)', value: 'America/Ensenada' },
    { name: 'America/Fort_Nelson (UTC -07:00)', value: 'America/Fort_Nelson' },
    { name: 'America/Fort_Wayne (UTC -04:00)', value: 'America/Fort_Wayne' },
    { name: 'America/Fortaleza (UTC -03:00)', value: 'America/Fortaleza' },
    { name: 'America/Glace_Bay (UTC -03:00)', value: 'America/Glace_Bay' },
    { name: 'America/Godthab (UTC -02:00)', value: 'America/Godthab' },
    { name: 'America/Goose_Bay (UTC -03:00)', value: 'America/Goose_Bay' },
    { name: 'America/Grand_Turk (UTC -04:00)', value: 'America/Grand_Turk' },
    { name: 'America/Grenada (UTC -04:00)', value: 'America/Grenada' },
    { name: 'America/Guadeloupe (UTC -04:00)', value: 'America/Guadeloupe' },
    { name: 'America/Guatemala (UTC -06:00)', value: 'America/Guatemala' },
    { name: 'America/Guayaquil (UTC -05:00)', value: 'America/Guayaquil' },
    { name: 'America/Guyana (UTC -04:00)', value: 'America/Guyana' },
    { name: 'America/Halifax (UTC -03:00)', value: 'America/Halifax' },
    { name: 'America/Havana (UTC -04:00)', value: 'America/Havana' },
    { name: 'America/Hermosillo (UTC -07:00)', value: 'America/Hermosillo' },
    { name: 'America/Indiana/Indianapolis (UTC -04:00)', value: 'America/Indiana/Indianapolis' },
    { name: 'America/Indiana/Knox (UTC -05:00)', value: 'America/Indiana/Knox' },
    { name: 'America/Indiana/Marengo (UTC -04:00)', value: 'America/Indiana/Marengo' },
    { name: 'America/Indiana/Petersburg (UTC -04:00)', value: 'America/Indiana/Petersburg' },
    { name: 'America/Indiana/Tell_City (UTC -05:00)', value: 'America/Indiana/Tell_City' },
    { name: 'America/Indiana/Vevay (UTC -04:00)', value: 'America/Indiana/Vevay' },
    { name: 'America/Indiana/Vincennes (UTC -04:00)', value: 'America/Indiana/Vincennes' },
    { name: 'America/Indiana/Winamac (UTC -04:00)', value: 'America/Indiana/Winamac' },
    { name: 'America/Indianapolis (UTC -04:00)', value: 'America/Indianapolis' },
    { name: 'America/Inuvik (UTC -06:00)', value: 'America/Inuvik' },
    { name: 'America/Iqaluit (UTC -04:00)', value: 'America/Iqaluit' },
    { name: 'America/Jamaica (UTC -05:00)', value: 'America/Jamaica' },
    { name: 'America/Jujuy (UTC -03:00)', value: 'America/Jujuy' },
    { name: 'America/Juneau (UTC -08:00)', value: 'America/Juneau' },
    { name: 'America/Kentucky/Louisville (UTC -04:00)', value: 'America/Kentucky/Louisville' },
    { name: 'America/Kentucky/Monticello (UTC -04:00)', value: 'America/Kentucky/Monticello' },
    { name: 'America/Knox_IN (UTC -05:00)', value: 'America/Knox_IN' },
    { name: 'America/Kralendijk (UTC -04:00)', value: 'America/Kralendijk' },
    { name: 'America/La_Paz (UTC -04:00)', value: 'America/La_Paz' },
    { name: 'America/Lima (UTC -05:00)', value: 'America/Lima' },
    { name: 'America/Los_Angeles (UTC -07:00)', value: 'America/Los_Angeles' },
    { name: 'America/Louisville (UTC -04:00)', value: 'America/Louisville' },
    { name: 'America/Lower_Princes (UTC -04:00)', value: 'America/Lower_Princes' },
    { name: 'America/Maceio (UTC -03:00)', value: 'America/Maceio' },
    { name: 'America/Managua (UTC -06:00)', value: 'America/Managua' },
    { name: 'America/Manaus (UTC -04:00)', value: 'America/Manaus' },
    { name: 'America/Marigot (UTC -04:00)', value: 'America/Marigot' },
    { name: 'America/Martinique (UTC -04:00)', value: 'America/Martinique' },
    { name: 'America/Matamoros (UTC -05:00)', value: 'America/Matamoros' },
    { name: 'America/Mazatlan (UTC -06:00)', value: 'America/Mazatlan' },
    { name: 'America/Mendoza (UTC -03:00)', value: 'America/Mendoza' },
    { name: 'America/Menominee (UTC -05:00)', value: 'America/Menominee' },
    { name: 'America/Merida (UTC -05:00)', value: 'America/Merida' },
    { name: 'America/Metlakatla (UTC -08:00)', value: 'America/Metlakatla' },
    { name: 'America/Mexico_City (UTC -05:00)', value: 'America/Mexico_City' },
    { name: 'America/Miquelon (UTC -02:00)', value: 'America/Miquelon' },
    { name: 'America/Moncton (UTC -03:00)', value: 'America/Moncton' },
    { name: 'America/Monterrey (UTC -05:00)', value: 'America/Monterrey' },
    { name: 'America/Montevideo (UTC -03:00)', value: 'America/Montevideo' },
    { name: 'America/Montreal (UTC -04:00)', value: 'America/Montreal' },
    { name: 'America/Montserrat (UTC -04:00)', value: 'America/Montserrat' },
    { name: 'America/Nassau (UTC -04:00)', value: 'America/Nassau' },
    { name: 'America/New_York (UTC -04:00)', value: 'America/New_York' },
    { name: 'America/Nipigon (UTC -04:00)', value: 'America/Nipigon' },
    { name: 'America/Nome (UTC -08:00)', value: 'America/Nome' },
    { name: 'America/Noronha (UTC -02:00)', value: 'America/Noronha' },
    { name: 'America/North_Dakota/Beulah (UTC -05:00)', value: 'America/North_Dakota/Beulah' },
    { name: 'America/North_Dakota/Center (UTC -05:00)', value: 'America/North_Dakota/Center' },
    { name: 'America/North_Dakota/New_Salem (UTC -05:00)', value: 'America/North_Dakota/New_Salem' },
    { name: 'America/Ojinaga (UTC -06:00)', value: 'America/Ojinaga' },
    { name: 'America/Panama (UTC -05:00)', value: 'America/Panama' },
    { name: 'America/Pangnirtung (UTC -04:00)', value: 'America/Pangnirtung' },
    { name: 'America/Paramaribo (UTC -03:00)', value: 'America/Paramaribo' },
    { name: 'America/Phoenix (UTC -07:00)', value: 'America/Phoenix' },
    { name: 'America/Port_of_Spain (UTC -04:00)', value: 'America/Port_of_Spain' },
    { name: 'America/Port-au-Prince (UTC -04:00)', value: 'America/Port-au-Prince' },
    { name: 'America/Porto_Acre (UTC -05:00)', value: 'America/Porto_Acre' },
    { name: 'America/Porto_Velho (UTC -04:00)', value: 'America/Porto_Velho' },
    { name: 'America/Puerto_Rico (UTC -04:00)', value: 'America/Puerto_Rico' },
    { name: 'America/Punta_Arenas (UTC -03:00)', value: 'America/Punta_Arenas' },
    { name: 'America/Rainy_River (UTC -05:00)', value: 'America/Rainy_River' },
    { name: 'America/Rankin_Inlet (UTC -05:00)', value: 'America/Rankin_Inlet' },
    { name: 'America/Recife (UTC -03:00)', value: 'America/Recife' },
    { name: 'America/Regina (UTC -06:00)', value: 'America/Regina' },
    { name: 'America/Resolute (UTC -05:00)', value: 'America/Resolute' },
    { name: 'America/Rio_Branco (UTC -05:00)', value: 'America/Rio_Branco' },
    { name: 'America/Rosario (UTC -03:00)', value: 'America/Rosario' },
    { name: 'America/Santa_Isabel (UTC -07:00)', value: 'America/Santa_Isabel' },
    { name: 'America/Santarem (UTC -03:00)', value: 'America/Santarem' },
    { name: 'America/Santiago (UTC -03:00)', value: 'America/Santiago' },
    { name: 'America/Santo_Domingo (UTC -04:00)', value: 'America/Santo_Domingo' },
    { name: 'America/Sao_Paulo (UTC -02:00)', value: 'America/Sao_Paulo' },
    { name: 'America/Scoresbysund (UTC +00:00)', value: 'America/Scoresbysund' },
    { name: 'America/Shiprock (UTC -06:00)', value: 'America/Shiprock' },
    { name: 'America/Sitka (UTC -08:00)', value: 'America/Sitka' },
    { name: 'America/St_Barthelemy (UTC -04:00)', value: 'America/St_Barthelemy' },
    { name: 'America/St_Johns (UTC -02:30)', value: 'America/St_Johns' },
    { name: 'America/St_Kitts (UTC -04:00)', value: 'America/St_Kitts' },
    { name: 'America/St_Lucia (UTC -04:00)', value: 'America/St_Lucia' },
    { name: 'America/St_Thomas (UTC -04:00)', value: 'America/St_Thomas' },
    { name: 'America/St_Vincent (UTC -04:00)', value: 'America/St_Vincent' },
    { name: 'America/Swift_Current (UTC -06:00)', value: 'America/Swift_Current' },
    { name: 'America/Tegucigalpa (UTC -06:00)', value: 'America/Tegucigalpa' },
    { name: 'America/Thule (UTC -03:00)', value: 'America/Thule' },
    { name: 'America/Thunder_Bay (UTC -04:00)', value: 'America/Thunder_Bay' },
    { name: 'America/Tijuana (UTC -07:00)', value: 'America/Tijuana' },
    { name: 'America/Toronto (UTC -04:00)', value: 'America/Toronto' },
    { name: 'America/Tortola (UTC -04:00)', value: 'America/Tortola' },
    { name: 'America/Vancouver (UTC -07:00)', value: 'America/Vancouver' },
    { name: 'America/Virgin (UTC -04:00)', value: 'America/Virgin' },
    { name: 'America/Whitehorse (UTC -07:00)', value: 'America/Whitehorse' },
    { name: 'America/Winnipeg (UTC -05:00)', value: 'America/Winnipeg' },
    { name: 'America/Yakutat (UTC -08:00)', value: 'America/Yakutat' },
    { name: 'America/Yellowknife (UTC -06:00)', value: 'America/Yellowknife' },
    { name: 'Antarctica/Casey (UTC +11:00)', value: 'Antarctica/Casey' },
    { name: 'Antarctica/Davis (UTC +07:00)', value: 'Antarctica/Davis' },
    { name: 'Antarctica/DumontDUrville (UTC +10:00)', value: 'Antarctica/DumontDUrville' },
    { name: 'Antarctica/Macquarie (UTC +11:00)', value: 'Antarctica/Macquarie' },
    { name: 'Antarctica/Mawson (UTC +05:00)', value: 'Antarctica/Mawson' },
    { name: 'Antarctica/McMurdo (UTC +13:00)', value: 'Antarctica/McMurdo' },
    { name: 'Antarctica/Palmer (UTC -03:00)', value: 'Antarctica/Palmer' },
    { name: 'Antarctica/Rothera (UTC -03:00)', value: 'Antarctica/Rothera' },
    { name: 'Antarctica/South_Pole (UTC +13:00)', value: 'Antarctica/South_Pole' },
    { name: 'Antarctica/Syowa (UTC +03:00)', value: 'Antarctica/Syowa' },
    { name: 'Antarctica/Troll (UTC +02:00)', value: 'Antarctica/Troll' },
    { name: 'Antarctica/Vostok (UTC +06:00)', value: 'Antarctica/Vostok' },
    { name: 'Arctic/Longyearbyen (UTC +02:00)', value: 'Arctic/Longyearbyen' },
    { name: 'Asia/Aden (UTC +03:00)', value: 'Asia/Aden' },
    { name: 'Asia/Almaty (UTC +06:00)', value: 'Asia/Almaty' },
    { name: 'Asia/Amman (UTC +03:00)', value: 'Asia/Amman' },
    { name: 'Asia/Anadyr (UTC +12:00)', value: 'Asia/Anadyr' },
    { name: 'Asia/Aqtau (UTC +05:00)', value: 'Asia/Aqtau' },
    { name: 'Asia/Aqtobe (UTC +05:00)', value: 'Asia/Aqtobe' },
    { name: 'Asia/Ashgabat (UTC +05:00)', value: 'Asia/Ashgabat' },
    { name: 'Asia/Ashkhabad (UTC +05:00)', value: 'Asia/Ashkhabad' },
    { name: 'Asia/Atyrau (UTC +05:00)', value: 'Asia/Atyrau' },
    { name: 'Asia/Baghdad (UTC +03:00)', value: 'Asia/Baghdad' },
    { name: 'Asia/Bahrain (UTC +03:00)', value: 'Asia/Bahrain' },
    { name: 'Asia/Baku (UTC +04:00)', value: 'Asia/Baku' },
    { name: 'Asia/Bangkok (UTC +07:00)', value: 'Asia/Bangkok' },
    { name: 'Asia/Barnaul (UTC +07:00)', value: 'Asia/Barnaul' },
    { name: 'Asia/Beirut (UTC +03:00)', value: 'Asia/Beirut' },
    { name: 'Asia/Bishkek (UTC +06:00)', value: 'Asia/Bishkek' },
    { name: 'Asia/Brunei (UTC +08:00)', value: 'Asia/Brunei' },
    { name: 'Asia/Calcutta (UTC +05:30)', value: 'Asia/Calcutta' },
    { name: 'Asia/Chita (UTC +09:00)', value: 'Asia/Chita' },
    { name: 'Asia/Choibalsan (UTC +08:00)', value: 'Asia/Choibalsan' },
    { name: 'Asia/Chongqing (UTC +08:00)', value: 'Asia/Chongqing' },
    { name: 'Asia/Chungking (UTC +08:00)', value: 'Asia/Chungking' },
    { name: 'Asia/Colombo (UTC +05:30)', value: 'Asia/Colombo' },
    { name: 'Asia/Dacca (UTC +06:00)', value: 'Asia/Dacca' },
    { name: 'Asia/Damascus (UTC +03:00)', value: 'Asia/Damascus' },
    { name: 'Asia/Dhaka (UTC +06:00)', value: 'Asia/Dhaka' },
    { name: 'Asia/Dili (UTC +09:00)', value: 'Asia/Dili' },
    { name: 'Asia/Dubai (UTC +04:00)', value: 'Asia/Dubai' },
    { name: 'Asia/Dushanbe (UTC +05:00)', value: 'Asia/Dushanbe' },
    { name: 'Asia/Famagusta (UTC +03:00)', value: 'Asia/Famagusta' },
    { name: 'Asia/Gaza (UTC +03:00)', value: 'Asia/Gaza' },
    { name: 'Asia/Harbin (UTC +08:00)', value: 'Asia/Harbin' },
    { name: 'Asia/Hebron (UTC +03:00)', value: 'Asia/Hebron' },
    { name: 'Asia/Ho_Chi_Minh (UTC +07:00)', value: 'Asia/Ho_Chi_Minh' },
    { name: 'Asia/Hong_Kong (UTC +08:00)', value: 'Asia/Hong_Kong' },
    { name: 'Asia/Hovd (UTC +07:00)', value: 'Asia/Hovd' },
    { name: 'Asia/Irkutsk (UTC +08:00)', value: 'Asia/Irkutsk' },
    { name: 'Asia/Istanbul (UTC +03:00)', value: 'Asia/Istanbul' },
    { name: 'Asia/Jakarta (UTC +07:00)', value: 'Asia/Jakarta' },
    { name: 'Asia/Jayapura (UTC +09:00)', value: 'Asia/Jayapura' },
    { name: 'Asia/Jerusalem (UTC +03:00)', value: 'Asia/Jerusalem' },
    { name: 'Asia/Kabul (UTC +04:30)', value: 'Asia/Kabul' },
    { name: 'Asia/Kamchatka (UTC +12:00)', value: 'Asia/Kamchatka' },
    { name: 'Asia/Karachi (UTC +05:00)', value: 'Asia/Karachi' },
    { name: 'Asia/Kashgar (UTC +06:00)', value: 'Asia/Kashgar' },
    { name: 'Asia/Kathmandu (UTC +05:45)', value: 'Asia/Kathmandu' },
    { name: 'Asia/Katmandu (UTC +05:45)', value: 'Asia/Katmandu' },
    { name: 'Asia/Khandyga (UTC +09:00)', value: 'Asia/Khandyga' },
    { name: 'Asia/Kolkata (UTC +05:30)', value: 'Asia/Kolkata' },
    { name: 'Asia/Krasnoyarsk (UTC +07:00)', value: 'Asia/Krasnoyarsk' },
    { name: 'Asia/Kuala_Lumpur (UTC +08:00)', value: 'Asia/Kuala_Lumpur' },
    { name: 'Asia/Kuching (UTC +08:00)', value: 'Asia/Kuching' },
    { name: 'Asia/Kuwait (UTC +03:00)', value: 'Asia/Kuwait' },
    { name: 'Asia/Macao (UTC +08:00)', value: 'Asia/Macao' },
    { name: 'Asia/Macau (UTC +08:00)', value: 'Asia/Macau' },
    { name: 'Asia/Magadan (UTC +11:00)', value: 'Asia/Magadan' },
    { name: 'Asia/Makassar (UTC +08:00)', value: 'Asia/Makassar' },
    { name: 'Asia/Manila (UTC +08:00)', value: 'Asia/Manila' },
    { name: 'Asia/Muscat (UTC +04:00)', value: 'Asia/Muscat' },
    { name: 'Asia/Nicosia (UTC +03:00)', value: 'Asia/Nicosia' },
    { name: 'Asia/Novokuznetsk (UTC +07:00)', value: 'Asia/Novokuznetsk' },
    { name: 'Asia/Novosibirsk (UTC +07:00)', value: 'Asia/Novosibirsk' },
    { name: 'Asia/Omsk (UTC +06:00)', value: 'Asia/Omsk' },
    { name: 'Asia/Oral (UTC +05:00)', value: 'Asia/Oral' },
    { name: 'Asia/Phnom_Penh (UTC +07:00)', value: 'Asia/Phnom_Penh' },
    { name: 'Asia/Pontianak (UTC +07:00)', value: 'Asia/Pontianak' },
    { name: 'Asia/Pyongyang (UTC +08:30)', value: 'Asia/Pyongyang' },
    { name: 'Asia/Qatar (UTC +03:00)', value: 'Asia/Qatar' },
    { name: 'Asia/Qyzylorda (UTC +06:00)', value: 'Asia/Qyzylorda' },
    { name: 'Asia/Rangoon (UTC +06:30)', value: 'Asia/Rangoon' },
    { name: 'Asia/Riyadh (UTC +03:00)', value: 'Asia/Riyadh' },
    { name: 'Asia/Saigon (UTC +07:00)', value: 'Asia/Saigon' },
    { name: 'Asia/Sakhalin (UTC +11:00)', value: 'Asia/Sakhalin' },
    { name: 'Asia/Samarkand (UTC +05:00)', value: 'Asia/Samarkand' },
    { name: 'Asia/Seoul (UTC +09:00)', value: 'Asia/Seoul' },
    { name: 'Asia/Shanghai (UTC +08:00)', value: 'Asia/Shanghai' },
    { name: 'Asia/Singapore (UTC +08:00)', value: 'Asia/Singapore' },
    { name: 'Asia/Srednekolymsk (UTC +11:00)', value: 'Asia/Srednekolymsk' },
    { name: 'Asia/Taipei (UTC +08:00)', value: 'Asia/Taipei' },
    { name: 'Asia/Tashkent (UTC +05:00)', value: 'Asia/Tashkent' },
    { name: 'Asia/Tbilisi (UTC +04:00)', value: 'Asia/Tbilisi' },
    { name: 'Asia/Tehran (UTC +04:30)', value: 'Asia/Tehran' },
    { name: 'Asia/Tel_Aviv (UTC +03:00)', value: 'Asia/Tel_Aviv' },
    { name: 'Asia/Thimbu (UTC +06:00)', value: 'Asia/Thimbu' },
    { name: 'Asia/Thimphu (UTC +06:00)', value: 'Asia/Thimphu' },
    { name: 'Asia/Tokyo (UTC +09:00)', value: 'Asia/Tokyo' },
    { name: 'Asia/Tomsk (UTC +07:00)', value: 'Asia/Tomsk' },
    { name: 'Asia/Ujung_Pandang (UTC +08:00)', value: 'Asia/Ujung_Pandang' },
    { name: 'Asia/Ulaanbaatar (UTC +08:00)', value: 'Asia/Ulaanbaatar' },
    { name: 'Asia/Ulan_Bator (UTC +08:00)', value: 'Asia/Ulan_Bator' },
    { name: 'Asia/Urumqi (UTC +06:00)', value: 'Asia/Urumqi' },
    { name: 'Asia/Ust-Nera (UTC +10:00)', value: 'Asia/Ust-Nera' },
    { name: 'Asia/Vientiane (UTC +07:00)', value: 'Asia/Vientiane' },
    { name: 'Asia/Vladivostok (UTC +10:00)', value: 'Asia/Vladivostok' },
    { name: 'Asia/Yakutsk (UTC +09:00)', value: 'Asia/Yakutsk' },
    { name: 'Asia/Yangon (UTC +06:30)', value: 'Asia/Yangon' },
    { name: 'Asia/Yekaterinburg (UTC +05:00)', value: 'Asia/Yekaterinburg' },
    { name: 'Asia/Yerevan (UTC +04:00)', value: 'Asia/Yerevan' },
    { name: 'Atlantic/Azores (UTC +00:00)', value: 'Atlantic/Azores' },
    { name: 'Atlantic/Bermuda (UTC -03:00)', value: 'Atlantic/Bermuda' },
    { name: 'Atlantic/Canary (UTC +01:00)', value: 'Atlantic/Canary' },
    { name: 'Atlantic/Cape_Verde (UTC -01:00)', value: 'Atlantic/Cape_Verde' },
    { name: 'Atlantic/Faeroe (UTC +01:00)', value: 'Atlantic/Faeroe' },
    { name: 'Atlantic/Faroe (UTC +01:00)', value: 'Atlantic/Faroe' },
    { name: 'Atlantic/Jan_Mayen (UTC +02:00)', value: 'Atlantic/Jan_Mayen' },
    { name: 'Atlantic/Madeira (UTC +01:00)', value: 'Atlantic/Madeira' },
    { name: 'Atlantic/Reykjavik (UTC +00:00)', value: 'Atlantic/Reykjavik' },
    { name: 'Atlantic/South_Georgia (UTC -02:00)', value: 'Atlantic/South_Georgia' },
    { name: 'Atlantic/St_Helena (UTC +00:00)', value: 'Atlantic/St_Helena' },
    { name: 'Atlantic/Stanley (UTC -03:00)', value: 'Atlantic/Stanley' },
    { name: 'Australia/ACT (UTC +11:00)', value: 'Australia/ACT' },
    { name: 'Australia/Adelaide (UTC +10:30)', value: 'Australia/Adelaide' },
    { name: 'Australia/Brisbane (UTC +10:00)', value: 'Australia/Brisbane' },
    { name: 'Australia/Broken_Hill (UTC +10:30)', value: 'Australia/Broken_Hill' },
    { name: 'Australia/Canberra (UTC +11:00)', value: 'Australia/Canberra' },
    { name: 'Australia/Currie (UTC +11:00)', value: 'Australia/Currie' },
    { name: 'Australia/Darwin (UTC +09:30)', value: 'Australia/Darwin' },
    { name: 'Australia/Eucla (UTC +08:45)', value: 'Australia/Eucla' },
    { name: 'Australia/Hobart (UTC +11:00)', value: 'Australia/Hobart' },
    { name: 'Australia/LHI (UTC +11:00)', value: 'Australia/LHI' },
    { name: 'Australia/Lindeman (UTC +10:00)', value: 'Australia/Lindeman' },
    { name: 'Australia/Lord_Howe (UTC +11:00)', value: 'Australia/Lord_Howe' },
    { name: 'Australia/Melbourne (UTC +11:00)', value: 'Australia/Melbourne' },
    { name: 'Australia/North (UTC +09:30)', value: 'Australia/North' },
    { name: 'Australia/NSW (UTC +11:00)', value: 'Australia/NSW' },
    { name: 'Australia/Perth (UTC +08:00)', value: 'Australia/Perth' },
    { name: 'Australia/Queensland (UTC +10:00)', value: 'Australia/Queensland' },
    { name: 'Australia/South (UTC +10:30)', value: 'Australia/South' },
    { name: 'Australia/Sydney (UTC +11:00)', value: 'Australia/Sydney' },
    { name: 'Australia/Tasmania (UTC +11:00)', value: 'Australia/Tasmania' },
    { name: 'Australia/Victoria (UTC +11:00)', value: 'Australia/Victoria' },
    { name: 'Australia/West (UTC +08:00)', value: 'Australia/West' },
    { name: 'Australia/Yancowinna (UTC +10:30)', value: 'Australia/Yancowinna' },
    { name: 'Brazil/Acre (UTC -05:00)', value: 'Brazil/Acre' },
    { name: 'Brazil/DeNoronha (UTC -02:00)', value: 'Brazil/DeNoronha' },
    { name: 'Brazil/East (UTC -02:00)', value: 'Brazil/East' },
    { name: 'Brazil/West (UTC -04:00)', value: 'Brazil/West' },
    { name: 'Canada/Atlantic (UTC -03:00)', value: 'Canada/Atlantic' },
    { name: 'Canada/Central (UTC -05:00)', value: 'Canada/Central' },
    { name: 'Canada/Eastern (UTC -04:00)', value: 'Canada/Eastern' },
    { name: 'Canada/East-Saskatchewan (UTC -06:00)', value: 'Canada/East-Saskatchewan' },
    { name: 'Canada/Mountain (UTC -06:00)', value: 'Canada/Mountain' },
    { name: 'Canada/Newfoundland (UTC -02:30)', value: 'Canada/Newfoundland' },
    { name: 'Canada/Pacific (UTC -07:00)', value: 'Canada/Pacific' },
    { name: 'Canada/Saskatchewan (UTC -06:00)', value: 'Canada/Saskatchewan' },
    { name: 'Canada/Yukon (UTC -07:00)', value: 'Canada/Yukon' },
    { name: 'CET (UTC +02:00)', value: 'CET' },
    { name: 'Chile/Continental (UTC -03:00)', value: 'Chile/Continental' },
    { name: 'Chile/EasterIsland (UTC -05:00)', value: 'Chile/EasterIsland' },
    { name: 'CST6CDT (UTC -05:00)', value: 'CST6CDT' },
    { name: 'Cuba (UTC -04:00)', value: 'Cuba' },
    { name: 'EET (UTC +03:00)', value: 'EET' },
    { name: 'Egypt (UTC +02:00)', value: 'Egypt' },
    { name: 'Eire (UTC +01:00)', value: 'Eire' },
    { name: 'EST (UTC -05:00)', value: 'EST' },
    { name: 'EST5EDT (UTC -04:00)', value: 'EST5EDT' },
    { name: 'Etc/GMT (UTC +00:00)', value: 'Etc/GMT' },
    { name: 'Etc/GMT+0 (UTC +00:00)', value: 'Etc/GMT+0' },
    { name: 'Etc/GMT+1 (UTC -01:00)', value: 'Etc/GMT+1' },
    { name: 'Etc/GMT+10 (UTC -10:00)', value: 'Etc/GMT+10' },
    { name: 'Etc/GMT+11 (UTC -11:00)', value: 'Etc/GMT+11' },
    { name: 'Etc/GMT+12 (UTC -12:00)', value: 'Etc/GMT+12' },
    { name: 'Etc/GMT+2 (UTC -02:00)', value: 'Etc/GMT+2' },
    { name: 'Etc/GMT+3 (UTC -03:00)', value: 'Etc/GMT+3' },
    { name: 'Etc/GMT+4 (UTC -04:00)', value: 'Etc/GMT+4' },
    { name: 'Etc/GMT+5 (UTC -05:00)', value: 'Etc/GMT+5' },
    { name: 'Etc/GMT+6 (UTC -06:00)', value: 'Etc/GMT+6' },
    { name: 'Etc/GMT+7 (UTC -07:00)', value: 'Etc/GMT+7' },
    { name: 'Etc/GMT+8 (UTC -08:00)', value: 'Etc/GMT+8' },
    { name: 'Etc/GMT+9 (UTC -09:00)', value: 'Etc/GMT+9' },
    { name: 'Etc/GMT0 (UTC +00:00)', value: 'Etc/GMT0' },
    { name: 'Etc/GMT-0 (UTC +00:00)', value: 'Etc/GMT-0' },
    { name: 'Etc/GMT-1 (UTC +01:00)', value: 'Etc/GMT-1' },
    { name: 'Etc/GMT-10 (UTC +10:00)', value: 'Etc/GMT-10' },
    { name: 'Etc/GMT-11 (UTC +11:00)', value: 'Etc/GMT-11' },
    { name: 'Etc/GMT-12 (UTC +12:00)', value: 'Etc/GMT-12' },
    { name: 'Etc/GMT-13 (UTC +13:00)', value: 'Etc/GMT-13' },
    { name: 'Etc/GMT-14 (UTC +14:00)', value: 'Etc/GMT-14' },
    { name: 'Etc/GMT-2 (UTC +02:00)', value: 'Etc/GMT-2' },
    { name: 'Etc/GMT-3 (UTC +03:00)', value: 'Etc/GMT-3' },
    { name: 'Etc/GMT-4 (UTC +04:00)', value: 'Etc/GMT-4' },
    { name: 'Etc/GMT-5 (UTC +05:00)', value: 'Etc/GMT-5' },
    { name: 'Etc/GMT-6 (UTC +06:00)', value: 'Etc/GMT-6' },
    { name: 'Etc/GMT-7 (UTC +07:00)', value: 'Etc/GMT-7' },
    { name: 'Etc/GMT-8 (UTC +08:00)', value: 'Etc/GMT-8' },
    { name: 'Etc/GMT-9 (UTC +09:00)', value: 'Etc/GMT-9' },
    { name: 'Etc/Greenwich (UTC +00:00)', value: 'Etc/Greenwich' },
    { name: 'Etc/UCT (UTC +00:00)', value: 'Etc/UCT' },
    { name: 'Etc/Universal (UTC +00:00)', value: 'Etc/Universal' },
    { name: 'Etc/UTC (UTC +00:00)', value: 'Etc/UTC' },
    { name: 'Etc/Zulu (UTC +00:00)', value: 'Etc/Zulu' },
    { name: 'Europe/Amsterdam (UTC +02:00)', value: 'Europe/Amsterdam' },
    { name: 'Europe/Andorra (UTC +02:00)', value: 'Europe/Andorra' },
    { name: 'Europe/Astrakhan (UTC +04:00)', value: 'Europe/Astrakhan' },
    { name: 'Europe/Athens (UTC +03:00)', value: 'Europe/Athens' },
    { name: 'Europe/Belfast (UTC +01:00)', value: 'Europe/Belfast' },
    { name: 'Europe/Belgrade (UTC +02:00)', value: 'Europe/Belgrade' },
    { name: 'Europe/Berlin (UTC +02:00)', value: 'Europe/Berlin' },
    { name: 'Europe/Bratislava (UTC +02:00)', value: 'Europe/Bratislava' },
    { name: 'Europe/Brussels (UTC +02:00)', value: 'Europe/Brussels' },
    { name: 'Europe/Bucharest (UTC +03:00)', value: 'Europe/Bucharest' },
    { name: 'Europe/Budapest (UTC +02:00)', value: 'Europe/Budapest' },
    { name: 'Europe/Busingen (UTC +02:00)', value: 'Europe/Busingen' },
    { name: 'Europe/Chisinau (UTC +03:00)', value: 'Europe/Chisinau' },
    { name: 'Europe/Copenhagen (UTC +02:00)', value: 'Europe/Copenhagen' },
    { name: 'Europe/Dublin (UTC +01:00)', value: 'Europe/Dublin' },
    { name: 'Europe/Gibraltar (UTC +02:00)', value: 'Europe/Gibraltar' },
    { name: 'Europe/Guernsey (UTC +01:00)', value: 'Europe/Guernsey' },
    { name: 'Europe/Helsinki (UTC +03:00)', value: 'Europe/Helsinki' },
    { name: 'Europe/Isle_of_Man (UTC +01:00)', value: 'Europe/Isle_of_Man' },
    { name: 'Europe/Istanbul (UTC +03:00)', value: 'Europe/Istanbul' },
    { name: 'Europe/Jersey (UTC +01:00)', value: 'Europe/Jersey' },
    { name: 'Europe/Kaliningrad (UTC +02:00)', value: 'Europe/Kaliningrad' },
    { name: 'Europe/Kiev (UTC +03:00)', value: 'Europe/Kiev' },
    { name: 'Europe/Kirov (UTC +03:00)', value: 'Europe/Kirov' },
    { name: 'Europe/Lisbon (UTC +01:00)', value: 'Europe/Lisbon' },
    { name: 'Europe/Ljubljana (UTC +02:00)', value: 'Europe/Ljubljana' },
    { name: 'Europe/London (UTC +01:00)', value: 'Europe/London' },
    { name: 'Europe/Luxembourg (UTC +02:00)', value: 'Europe/Luxembourg' },
    { name: 'Europe/Madrid (UTC +02:00)', value: 'Europe/Madrid' },
    { name: 'Europe/Malta (UTC +02:00)', value: 'Europe/Malta' },
    { name: 'Europe/Mariehamn (UTC +03:00)', value: 'Europe/Mariehamn' },
    { name: 'Europe/Minsk (UTC +03:00)', value: 'Europe/Minsk' },
    { name: 'Europe/Monaco (UTC +02:00)', value: 'Europe/Monaco' },
    { name: 'Europe/Moscow (UTC +03:00)', value: 'Europe/Moscow' },
    { name: 'Europe/Nicosia (UTC +03:00)', value: 'Europe/Nicosia' },
    { name: 'Europe/Oslo (UTC +02:00)', value: 'Europe/Oslo' },
    { name: 'Europe/Paris (UTC +02:00)', value: 'Europe/Paris' },
    { name: 'Europe/Podgorica (UTC +02:00)', value: 'Europe/Podgorica' },
    { name: 'Europe/Prague (UTC +02:00)', value: 'Europe/Prague' },
    { name: 'Europe/Riga (UTC +03:00)', value: 'Europe/Riga' },
    { name: 'Europe/Rome (UTC +02:00)', value: 'Europe/Rome' },
    { name: 'Europe/Samara (UTC +04:00)', value: 'Europe/Samara' },
    { name: 'Europe/San_Marino (UTC +02:00)', value: 'Europe/San_Marino' },
    { name: 'Europe/Sarajevo (UTC +02:00)', value: 'Europe/Sarajevo' },
    { name: 'Europe/Saratov (UTC +04:00)', value: 'Europe/Saratov' },
    { name: 'Europe/Simferopol (UTC +03:00)', value: 'Europe/Simferopol' },
    { name: 'Europe/Skopje (UTC +02:00)', value: 'Europe/Skopje' },
    { name: 'Europe/Sofia (UTC +03:00)', value: 'Europe/Sofia' },
    { name: 'Europe/Stockholm (UTC +02:00)', value: 'Europe/Stockholm' },
    { name: 'Europe/Tallinn (UTC +03:00)', value: 'Europe/Tallinn' },
    { name: 'Europe/Tirane (UTC +02:00)', value: 'Europe/Tirane' },
    { name: 'Europe/Tiraspol (UTC +03:00)', value: 'Europe/Tiraspol' },
    { name: 'Europe/Ulyanovsk (UTC +04:00)', value: 'Europe/Ulyanovsk' },
    { name: 'Europe/Uzhgorod (UTC +03:00)', value: 'Europe/Uzhgorod' },
    { name: 'Europe/Vaduz (UTC +02:00)', value: 'Europe/Vaduz' },
    { name: 'Europe/Vatican (UTC +02:00)', value: 'Europe/Vatican' },
    { name: 'Europe/Vienna (UTC +02:00)', value: 'Europe/Vienna' },
    { name: 'Europe/Vilnius (UTC +03:00)', value: 'Europe/Vilnius' },
    { name: 'Europe/Volgograd (UTC +03:00)', value: 'Europe/Volgograd' },
    { name: 'Europe/Warsaw (UTC +02:00)', value: 'Europe/Warsaw' },
    { name: 'Europe/Zagreb (UTC +02:00)', value: 'Europe/Zagreb' },
    { name: 'Europe/Zaporozhye (UTC +03:00)', value: 'Europe/Zaporozhye' },
    { name: 'Europe/Zurich (UTC +02:00)', value: 'Europe/Zurich' },
    { name: 'GB (UTC +01:00)', value: 'GB' },
    { name: 'GB-Eire (UTC +01:00)', value: 'GB-Eire' },
    { name: 'GMT (UTC +00:00)', value: 'GMT' },
    { name: 'GMT+0 (UTC +00:00)', value: 'GMT+0' },
    { name: 'GMT0 (UTC +00:00)', value: 'GMT0' },
    { name: 'GMT-0 (UTC +00:00)', value: 'GMT-0' },
    { name: 'Greenwich (UTC +00:00)', value: 'Greenwich' },
    { name: 'Hongkong (UTC +08:00)', value: 'Hongkong' },
    { name: 'HST (UTC -10:00)', value: 'HST' },
    { name: 'Iceland (UTC +00:00)', value: 'Iceland' },
    { name: 'Indian/Antananarivo (UTC +03:00)', value: 'Indian/Antananarivo' },
    { name: 'Indian/Chagos (UTC +06:00)', value: 'Indian/Chagos' },
    { name: 'Indian/Christmas (UTC +07:00)', value: 'Indian/Christmas' },
    { name: 'Indian/Cocos (UTC +06:30)', value: 'Indian/Cocos' },
    { name: 'Indian/Comoro (UTC +03:00)', value: 'Indian/Comoro' },
    { name: 'Indian/Kerguelen (UTC +05:00)', value: 'Indian/Kerguelen' },
    { name: 'Indian/Mahe (UTC +04:00)', value: 'Indian/Mahe' },
    { name: 'Indian/Maldives (UTC +05:00)', value: 'Indian/Maldives' },
    { name: 'Indian/Mauritius (UTC +04:00)', value: 'Indian/Mauritius' },
    { name: 'Indian/Mayotte (UTC +03:00)', value: 'Indian/Mayotte' },
    { name: 'Indian/Reunion (UTC +04:00)', value: 'Indian/Reunion' },
    { name: 'Iran (UTC +04:30)', value: 'Iran' },
    { name: 'Israel (UTC +03:00)', value: 'Israel' },
    { name: 'Jamaica (UTC -05:00)', value: 'Jamaica' },
    { name: 'Japan (UTC +09:00)', value: 'Japan' },
    { name: 'Kwajalein (UTC +12:00)', value: 'Kwajalein' },
    { name: 'Libya (UTC +02:00)', value: 'Libya' },
    { name: 'MET (UTC +02:00)', value: 'MET' },
    { name: 'Mexico/BajaNorte (UTC -07:00)', value: 'Mexico/BajaNorte' },
    { name: 'Mexico/BajaSur (UTC -06:00)', value: 'Mexico/BajaSur' },
    { name: 'Mexico/General (UTC -05:00)', value: 'Mexico/General' },
    { name: 'MST (UTC -07:00)', value: 'MST' },
    { name: 'MST7MDT (UTC -06:00)', value: 'MST7MDT' },
    { name: 'Navajo (UTC -06:00)', value: 'Navajo' },
    { name: 'NZ (UTC +13:00)', value: 'NZ' },
    { name: 'NZ-CHAT (UTC +13:45)', value: 'NZ-CHAT' },
    { name: 'Pacific/Apia (UTC +14:00)', value: 'Pacific/Apia' },
    { name: 'Pacific/Auckland (UTC +13:00)', value: 'Pacific/Auckland' },
    { name: 'Pacific/Bougainville (UTC +11:00)', value: 'Pacific/Bougainville' },
    { name: 'Pacific/Chatham (UTC +13:45)', value: 'Pacific/Chatham' },
    { name: 'Pacific/Chuuk (UTC +10:00)', value: 'Pacific/Chuuk' },
    { name: 'Pacific/Easter (UTC -05:00)', value: 'Pacific/Easter' },
    { name: 'Pacific/Efate (UTC +11:00)', value: 'Pacific/Efate' },
    { name: 'Pacific/Enderbury (UTC +13:00)', value: 'Pacific/Enderbury' },
    { name: 'Pacific/Fakaofo (UTC +13:00)', value: 'Pacific/Fakaofo' },
    { name: 'Pacific/Fiji (UTC +13:00)', value: 'Pacific/Fiji' },
    { name: 'Pacific/Funafuti (UTC +12:00)', value: 'Pacific/Funafuti' },
    { name: 'Pacific/Galapagos (UTC -06:00)', value: 'Pacific/Galapagos' },
    { name: 'Pacific/Gambier (UTC -09:00)', value: 'Pacific/Gambier' },
    { name: 'Pacific/Guadalcanal (UTC +11:00)', value: 'Pacific/Guadalcanal' },
    { name: 'Pacific/Guam (UTC +10:00)', value: 'Pacific/Guam' },
    { name: 'Pacific/Honolulu (UTC -10:00)', value: 'Pacific/Honolulu' },
    { name: 'Pacific/Johnston (UTC -10:00)', value: 'Pacific/Johnston' },
    { name: 'Pacific/Kiritimati (UTC +14:00)', value: 'Pacific/Kiritimati' },
    { name: 'Pacific/Kosrae (UTC +11:00)', value: 'Pacific/Kosrae' },
    { name: 'Pacific/Kwajalein (UTC +12:00)', value: 'Pacific/Kwajalein' },
    { name: 'Pacific/Majuro (UTC +12:00)', value: 'Pacific/Majuro' },
    { name: 'Pacific/Marquesas (UTC -09:30)', value: 'Pacific/Marquesas' },
    { name: 'Pacific/Midway (UTC -11:00)', value: 'Pacific/Midway' },
    { name: 'Pacific/Nauru (UTC +12:00)', value: 'Pacific/Nauru' },
    { name: 'Pacific/Niue (UTC -11:00)', value: 'Pacific/Niue' },
    { name: 'Pacific/Norfolk (UTC +11:00)', value: 'Pacific/Norfolk' },
    { name: 'Pacific/Noumea (UTC +11:00)', value: 'Pacific/Noumea' },
    { name: 'Pacific/Pago_Pago (UTC -11:00)', value: 'Pacific/Pago_Pago' },
    { name: 'Pacific/Palau (UTC +09:00)', value: 'Pacific/Palau' },
    { name: 'Pacific/Pitcairn (UTC -08:00)', value: 'Pacific/Pitcairn' },
    { name: 'Pacific/Pohnpei (UTC +11:00)', value: 'Pacific/Pohnpei' },
    { name: 'Pacific/Ponape (UTC +11:00)', value: 'Pacific/Ponape' },
    { name: 'Pacific/Port_Moresby (UTC +10:00)', value: 'Pacific/Port_Moresby' },
    { name: 'Pacific/Rarotonga (UTC -10:00)', value: 'Pacific/Rarotonga' },
    { name: 'Pacific/Saipan (UTC +10:00)', value: 'Pacific/Saipan' },
    { name: 'Pacific/Samoa (UTC -11:00)', value: 'Pacific/Samoa' },
    { name: 'Pacific/Tahiti (UTC -10:00)', value: 'Pacific/Tahiti' },
    { name: 'Pacific/Tarawa (UTC +12:00)', value: 'Pacific/Tarawa' },
    { name: 'Pacific/Tongatapu (UTC +14:00)', value: 'Pacific/Tongatapu' },
    { name: 'Pacific/Truk (UTC +10:00)', value: 'Pacific/Truk' },
    { name: 'Pacific/Wake (UTC +12:00)', value: 'Pacific/Wake' },
    { name: 'Pacific/Wallis (UTC +12:00)', value: 'Pacific/Wallis' },
    { name: 'Pacific/Yap (UTC +10:00)', value: 'Pacific/Yap' },
    { name: 'Poland (UTC +02:00)', value: 'Poland' },
    { name: 'Portugal (UTC +01:00)', value: 'Portugal' },
    { name: 'PRC (UTC +08:00)', value: 'PRC' },
    { name: 'PST8PDT (UTC -07:00)', value: 'PST8PDT' },
    { name: 'ROC (UTC +08:00)', value: 'ROC' },
    { name: 'ROK (UTC +09:00)', value: 'ROK' },
    { name: 'Singapore (UTC +08:00)', value: 'Singapore' },
    { name: 'Turkey (UTC +03:00)', value: 'Turkey' },
    { name: 'UCT (UTC +00:00)', value: 'UCT' },
    { name: 'Universal (UTC +00:00)', value: 'Universal' },
    { name: 'US/Alaska (UTC -08:00)', value: 'US/Alaska' },
    { name: 'US/Aleutian (UTC -09:00)', value: 'US/Aleutian' },
    { name: 'US/Arizona (UTC -07:00)', value: 'US/Arizona' },
    { name: 'US/Central (UTC -05:00)', value: 'US/Central' },
    { name: 'US/Eastern (UTC -04:00)', value: 'US/Eastern' },
    { name: 'US/East-Indiana (UTC -04:00)', value: 'US/East-Indiana' },
    { name: 'US/Hawaii (UTC -10:00)', value: 'US/Hawaii' },
    { name: 'US/Indiana-Starke (UTC -05:00)', value: 'US/Indiana-Starke' },
    { name: 'US/Michigan (UTC -04:00)', value: 'US/Michigan' },
    { name: 'US/Mountain (UTC -06:00)', value: 'US/Mountain' },
    { name: 'US/Pacific (UTC -07:00)', value: 'US/Pacific' },
    { name: 'US/Pacific-New (UTC -07:00)', value: 'US/Pacific-New' },
    { name: 'US/Samoa (UTC -11:00)', value: 'US/Samoa' },
    { name: 'UTC (UTC +00:00)', value: 'UTC' },
    { name: 'WET (UTC +01:00)', value: 'WET' },
    { name: 'W-SU (UTC +03:00)', value: 'W-SU' },
    { name: 'Zulu (UTC +00:00)', value: 'Zulu' }
];